var React = require('react');

function Four (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"matrix(4.166666666666667,0,0,4.166666666666667,0,0)"},[React.createElement("path",{"d":"M23.5,1.5a1,1,0,0,0-1-1H4.5a1,1,0,0,0-1,1v18a1,1,0,0,0,1,1h18a1,1,0,0,0,1-1Z","fill":"none","stroke":"#da1884","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M3.5,4.5h-2a1,1,0,0,0-1,1v17a1,1,0,0,0,1,1h17a1,1,0,0,0,1-1v-2","fill":"none","stroke":"#da1884","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M15.5,14.5v-8a5,5,0,0,0-5,5v1h5","fill":"none","stroke":"#da1884","strokeLinecap":"round","strokeLinejoin":"round","key":2})]));
}

Four.defaultProps = {"version":"1.1","xmlnsSvgjs":"http://svgjs.com/svgjs","viewBox":"0 0 100 100","width":"100","height":"100"};

module.exports = Four;

Four.default = Four;
